"use strict";

jQuery(document).ready(function ($) {
  $('.quotes__carousel').slick({
    autoplay: true,
    arrows: true,
    prevArrow: '<span class="quotes__carousel__arrow quotes__carousel__arrow--prev"></span>',
    nextArrow: '<span class="quotes__carousel__arrow quotes__carousel__arrow--next"></span>',
    pauseOnHover: true,
    dots: false,
    autoplaySpeed: 5000,
    speed: 400,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [{
      breakpoint: 640,
      settings: {
        arrows: false,
        dotsClass: 'quotes__dots',
        dots: true
      }
    }]
  });
});